/**
 * The containers card's head: "3 containers have drops outside the window"
 * — click to list only them, click again to list every container.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { Moon, X } from 'lucide-react';

import { cn } from '@/lib/utils';

interface Props {
  count: number;
  active: boolean;
  onToggle: () => void;
}

export const OutsideFilterChip: FC<Props> = ({ count, active, onToggle }) => {
  if (count === 0 && !active) return null;
  const label = `${count} container${count === 1 ? ' has' : 's have'} drops outside the window`;
  return (
    <button
      type="button"
      aria-pressed={active}
      onClick={onToggle}
      title={active ? 'Showing only these (reordering is off) — click to list every container' : 'Their drops outside the window are not sent. Click to list only them.'}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[11px] font-medium transition-colors',
        active ? 'border-warning bg-warning/15 text-warning' : 'border-warning/40 text-warning hover:bg-warning/10',
      )}
    >
      <Moon className="h-3 w-3" aria-hidden />
      {label}
      {active ? <X className="h-3 w-3" aria-label="Show every container" /> : null}
    </button>
  );
};
